var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",staticStyle:{"align-items":"start"}},[_c('h3',[_vm._v("Карта проезда")]),_c('h4',[_vm._v(_vm._s(_vm.adres))]),_c('div',{staticStyle:{"width":"100%","height":"400px"},attrs:{"id":"map2"}})])}
var staticRenderFns = []

export { render, staticRenderFns }